import type { ReactNode } from "react";
import { createContext, useContext, useState } from "react";
import type { Template } from "../../../generated/WorkflowsApi.types";
import { useWorkflowTemplateRefreshFlag } from "../../../hooks/useWorkflowTemplateRefreshFlag";
import { useTemplates } from "./useTemplates";

export interface WorkflowFormData {
  isLoadingTemplates: boolean;
  selectedCategory: string;
  selectedTemplateId?: string;
  setSelectedCategory: (category: string) => void;
  templates: Template[];
  totalCount: number;
}

const WorkflowFormData = createContext<WorkflowFormData>({
  templates: [],
  totalCount: 0,
  isLoadingTemplates: false,
  selectedCategory: "all",
  selectedTemplateId: undefined,
  setSelectedCategory: () => {},
});
WorkflowFormData.displayName = "WorkflowFormData";

export interface CreateWorkflowProviderProps {
  category?: string;
  children: ReactNode;
}

export const CreateWorkflowProvider = ({
  children,
  category,
}: CreateWorkflowProviderProps) => {
  const isWorkflowTemplateRefreshEnabled = useWorkflowTemplateRefreshFlag();

  const [selectedCategory, setSelectedCategory] = useState(category || "all");

  const templateCategory = isWorkflowTemplateRefreshEnabled
    ? selectedCategory
    : "all";
  const {
    templates,
    totalCount,
    isLoading: isLoadingTemplates,
  } = useTemplates(templateCategory);

  return (
    <WorkflowFormData.Provider
      value={{
        templates,
        totalCount,
        isLoadingTemplates,
        selectedCategory,
        setSelectedCategory,
      }}
    >
      {children}
    </WorkflowFormData.Provider>
  );
};

export const useCreateWorkflowData = () => useContext(WorkflowFormData);
